export default __webpack_public_path__ + "static/media/Soulbou.c6f04f65.png";